import { Component, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
  selector: "preview-image",
  templateUrl: "preview-image.component.html",
})
export class PreviewImageComponent implements OnInit {
  imageFromBlob: SafeUrl;
  imageUrl: string;

  constructor(
    private modalService: BsModalService,
    private modalRef: BsModalRef,
    private sanitizer: DomSanitizer
  ) {
    this.imageUrl = null;
  }

  ngOnInit(): void {
    const config: any = { ...this.modalService.config.initialState };
    if (config.imageUrl) {
      this.imageUrl = config.imageUrl;
    }
    if (config.imageBlob) {
      this.loadBlobImage(config.imageBlob);
    }
  }

  closePreview(): void {
    this.modalRef.hide();
  }

  private loadBlobImage(blob: Blob): void {
    let objectURL = URL.createObjectURL(blob);
    this.imageFromBlob = this.sanitizer.bypassSecurityTrustUrl(objectURL);
  }
}
